module.exports = __webpack_public_path__ + "static/media/extractor.161a9ab6.webp";